module Meevo.Plugins.Tippy {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class EmployeesSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        excludedEmployeeList: string[] = [];
        //store meevo employees on save so don't have to re-get to populate save response
        storedMeevoEmployees: Model.EmployeeListItem[];

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            private modalService: Meevo.Components.Modal.IModalService,
            protected $rootScope: angular.IRootScopeService,
            private meevoDataService: Meevo.Components.BaseClasses.IDataService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)
        }

        get isReadonly(): boolean {
            return true;
        }        

        sectionModelRetrieved(): void {
            super.sectionModelRetrieved();

            if (this.model.tipProcessingDisabled) {
                this.modalService.error("MESSAGE_NO_TIPPY_EMPLOYEES");
            }

            let employeeIds = _(this.model.mappings).chain()
                .filter(mapping => angular.isDefined(mapping.meevoEmployeeId))
                .map(mapping => mapping.meevoEmployeeId)
                .uniq()
                .value();

            if (employeeIds.length == 0) {
                return;
            }

            this.meevoDataService.customMethodData(`/api/employee/list`, "POST", {
                criteria: {
                    employeeIds: employeeIds
                }
            }).then(response => {
                for (let mapping of _(this.model.mappings).filter(mapping => angular.isDefined(mapping.meevoEmployeeId))) {
                    mapping.employee = response.data.find(employee => employee.id === mapping.meevoEmployeeId);
                    if (!mapping.employee || mapping.employee.objectState != Meevo.Model.ObjectStateEnum.Active) {
                        mapping.employee = null;
                        mapping.meevoEmployeeId = null;
                    }
                }
                
                this.buildExcludedEmployeeList();
            })
        }

        private buildExcludedEmployeeList(): void {
            this.excludedEmployeeList = this.model.mappings.filter(tippyEmployeeMapping => angular.isDefined(tippyEmployeeMapping.employee))
                .map(tippyEmployeeMapping => tippyEmployeeMapping.employee);
        }

        employeeChanged(tippyEmployeeMapping): void {
            tippyEmployeeMapping.meevoEmployeeId = null;
            tippyEmployeeMapping.fullEmployeeLoaded = false;
            this.buildExcludedEmployeeList();
            if (tippyEmployeeMapping.employee) {
                tippyEmployeeMapping.meevoEmployeeId = tippyEmployeeMapping.employee.id;
                //in case details are currently expanded
                this.getFullEmployee(tippyEmployeeMapping);
            }
        }

        goToEmployeeLink(employeeId) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: "employee",
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Editing,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: "tippy",
                    id: employeeId,
                    initialEditSection: "SECTION_EMPLOYEE_MAIN"
                }
            });
        }

        expandCallback(index) {
            let mapping = this.model.mappings[index];
            if (!mapping.employee) {
                return;
            }

            this.getFullEmployee(mapping);
        }

        getFullEmployee(mapping) {
            if (mapping.fullEmployeeLoaded) {
                return;
            }
            this.meevoDataService.customMethodData(`/api/employee/${mapping.employee.id}`, "GET", {}).then(response => {
                mapping.employee = response.data;
                mapping.fullEmployeeLoaded = true;
            })
        }

        preSave() {
            super.preSave();
            this.storedMeevoEmployees = [];
            for (let mapping of this.model.mappings) {
                mapping.employeeId = mapping.employee ? mapping.employee.id : undefined;
                if (mapping.employee) {
                    this.storedMeevoEmployees.push(mapping.employee);
                }
            }
        }

        activate() {
            if (this.model && this.storedMeevoEmployees) { 
                for (let mapping of this.model.mappings) {
                    if (mapping.meevoEmployeeId) {
                        mapping.employee = _(this.storedMeevoEmployees).find(employee => employee.id === mapping.meevoEmployeeId);
                    }
                }
            }
        }
    }
}